export const cardFees = {
    LCLLF_MONTHLY_FEE: 550,
    MONTHLY_FEE: 900,
    ONE_TINE_FEE: 900,
    METAL_CARD_FEE: 3500,
};
